import request from '@/utils/request'
const apiPath = '/course/courseOrder'
import { downloadBlob } from '@/utils/download'
const courseOrderApi = {
  /**
   * 新增【课程订单】
   */
  create(data) {
    return request.post(apiPath, data)
  },
  /**
   * 修改【课程订单】
   */
  update(data) {
    return request.put(apiPath, data)
  },
  /**
   * 分页查询【课程订单】
   */
  fetchList(query) {
    return request.get(apiPath, { params: query })
  },
  findOptions(query) {
    return request.get(`${apiPath}/options`, { params: query })
  },
  /**
   * 查看【课程订单】详情
   */
  fetchById(id) {
    return request.get(`${apiPath}/${id}`)
  },
  exportCourseOrder(query) {
    return request.get(apiPath + '/exportCourseOrder', { params: query })
  },
  exportCourseOrderReconciliation(query) {
    return request.get(apiPath + '/exportCourseOrderReconciliation', { params: query })
  },
  /**
   * 删除单个【课程订单】
   */
}
export default courseOrderApi

